/**
 * this function returns an jsx element containing the summary about the indicators.
 * @param {array} data
 * @returns {JSX.Element}
 */
export default function getSummaryInCard(data) {
  if (!data) {
    return null;
  }

  const sortedData = data.sort(function (a, b) {
    return b.value - a.value;
  });

  return sortedData.map((item, i) => {
    if (i === 0) {
      return (
        <a
          className="nav-link"
          key={i}
          href={"#/"}
          style={{ pointerEvents: "none" }}
        >
          <span style={{ color: item.color, fontSize: 13 }}>
            {item.name} {item.icon} {item.value}
          </span>
        </a>
      );
    } else {
      return (
        //Highlight only the first element (More indications)
        <a
          className="nav-link"
          key={i}
          href={"#/"}
          style={{ pointerEvents: "none" }}
        >
          <span style={{ color: "var(--text-7)", fontSize: 10 }}>
            {item.name} {item.icon} {item.value}
          </span>
        </a>
      );
    }
  });
}

export const navStyle = {
  backgroundColor: "var(--bg-11)",
  borderBottomRightRadius: 10,
  borderBottomLeftRadius: 10,
  justifyContent: "center",
};
